import { DomUtils } from "../utils/domUtils";

export const FooterConstants = {
	copyrightYear: "copyrightYear"
};

export class FooterController {
	Init() {
		this._SetCopyrightYear();
	}

	_SetCopyrightYear() {
		const currentYear = new Date().getFullYear();
		const yearElem = DomUtils.GetElement(FooterConstants.copyrightYear);
		yearElem.innerText = String(currentYear);
	}
}
